import React, { useContext, useState, useEffect } from "react";
import {
  Drawer,
  Hidden,
  SwipeableDrawer,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Toolbar,
  Avatar,
  Typography,
} from "@mui/material";
import Helper from "../../common/Helper";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import GamepadIcon from "@mui/icons-material/Gamepad";
import { makeStyles } from "@mui/styles";
import { AppDataContext } from "../../common/appContext";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { RoutePermissions, RouteScreens } from "../../common/RoutePermissions";
import { useParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDrawer-paper": {
      background: "linear-gradient(90deg,#183577 20%,#1c439b 70%)",
      color: "white",
    },
    "& svg": {
      color: "#ffffff",
    },
  },
  infoBar: {
    backgroundColor: theme.palette.primary.main,
  },
  avatar: {
    backgroundColor: theme.palette.primary.dark,
  },
}));
export default function SidebarMenu(props) {
  const classes = useStyles();

  const { user, selectedEventId } = useContext(AppDataContext);
  let userAppRoles = user.appRoles || [];
  let navigate = useNavigate();

  const [eventId, setEventId] = useState(selectedEventId);

  useEffect(() => {
    setEventId(selectedEventId);
  }, [selectedEventId]);
  const handleGameAuditClick = () => {
    navigate(RouteConstants.GAME_AUDIT);
  };

  const handleTeamBallotDashboardClick = () => {
    navigate(RouteConstants.TEAM_BALLOT_DASHBOARD);
  };

  const handleTeamGreenBallotDashboardClick = () => {
    navigate(RouteConstants.TEAM_GREEN_BALLOT_VOTE);
  };

  const handleAdminBallotDashboardClick = () => {
    navigate(RouteConstants.ADMIN_BALLOT_DASHBOARD);
  };

  const handleManagePermissionClick = () => {
    navigate(RouteConstants.MANAGEMENT_PERMISSION);
  };

  const handleAdminPreferencesClick = () => {
    navigate(RouteConstants.ADMIN_PREFERENCES);
  };

  const handlePlayerListClick = () => {
    navigate(`/${eventId}${RouteConstants.PLAYER_LIST}`);
  };

  const handleManagePlayerCareerStatsClick = () => {
    navigate(RouteConstants.MANAGE_PLAYER_CAREER_STATS);
  };

  const handleCombineResultListClick = () => {
    navigate(`/${eventId}${RouteConstants.COMBINE_RESULTS}`);
  };
  const handleComparePlayertListClick = () => {
    navigate(`/${eventId}${RouteConstants.COMPARE_PLAYERS}`);
  };
  const handleCareerStatsListClick = () => {
    navigate(`/${eventId}${RouteConstants.CAREER_STATS}`);
  };
  const list = () => (
    <Box
      sx={{
        width: 250,
      }}
      role="presentation"
      onClick={(e) => props.toggleDrawer(e, false)}
      onKeyDown={(e) => props.toggleDrawer(e, false)}
    >
      <Toolbar className={classes.infoBar}>
        <Avatar className={classes.avatar}>
          {user && Helper.GetNameInitials(`${user.firstName} ${user.lastName}`)}
        </Avatar>
        <Typography
          variant="subtitle1"
          sx={{
            color: "#c6c4c6",
            paddingLeft: (theme) => theme.spacing(2),
            fontWeight: 300,
          }}
        >{`${user.firstName} ${user.lastName}`}</Typography>
      </Toolbar>
      <Divider />

      <List dense>
        {/* {RoutePermissions.IsAuthorized(
          RouteScreens.AdminGameAudit,
          userAppRoles
        ) ? (
          <ListItem button onClick={handleGameAuditClick}>
            <ListItemIcon>
              <GamepadIcon />
            </ListItemIcon>
            <ListItemText primary="Game Audit" />
          </ListItem>
        ) : (
          ""
        )} */}

        {RoutePermissions.IsAuthorized(
          RouteScreens.TeamBallotDashboard,
          userAppRoles
        ) ? (
          <ListItem button onClick={handleTeamBallotDashboardClick}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Team Ballot Dashboard" />
          </ListItem>
        ) : (
          ""
        )}

        {RoutePermissions.IsAuthorized(
          RouteScreens.TeamGreenBallotVote,
          userAppRoles
        ) ? (
          <ListItem button onClick={handleTeamGreenBallotDashboardClick}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Green Room Ballot" />
          </ListItem>
        ) : (
          ""
        )}

        {RoutePermissions.IsAuthorized(
          RouteScreens.AdminBallotDashboard,
          userAppRoles
        ) ? (
          <ListItem button onClick={handleAdminBallotDashboardClick}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Admin Ballot Dashboard" />
          </ListItem>
        ) : (
          ""
        )}

        {/* {RoutePermissions.IsAuthorized(
          RouteScreens.AdminManagePermissions,
          userAppRoles
        ) ? (
          <ListItem button onClick={handleManagePermissionClick}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Manage Permission" />
          </ListItem>
        ) : (
          ""
        )} */}

        {RoutePermissions.IsAuthorized(
          RouteScreens.AdminPreferences,
          userAppRoles
        ) ? (
          <ListItem button onClick={handleAdminPreferencesClick}>
            <ListItemIcon>
              <AdminPanelSettingsIcon />
            </ListItemIcon>
            <ListItemText primary="Admin Preferences" />
          </ListItem>
        ) : (
          ""
        )}

        {user.isAdmin ||
        (RoutePermissions.IsAuthorized(
          RouteScreens.ViewPlayerProfile,
          userAppRoles
        ) &&
          user.playerProfileFlag) ? (
          <ListItem button onClick={handlePlayerListClick}>
            <ListItemIcon>
              <PersonOutlineIcon />
            </ListItemIcon>
            <ListItemText primary="Player Profiles" />
          </ListItem>
        ) : (
          ""
        )}

        {user.isAdmin ||
        (RoutePermissions.IsAuthorized(
          RouteScreens.CombineResults,
          userAppRoles
        ) &&
          user.combineResultsFlag) ? (
          <ListItem button onClick={handleCombineResultListClick}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Combine Results" />
          </ListItem>
        ) : (
          ""
        )}

        {user.isAdmin ||
        (RoutePermissions.IsAuthorized(
          RouteScreens.CombineResults,
          userAppRoles
        ) &&
          user.combineResultsFlag) ? (
          <ListItem button onClick={handleComparePlayertListClick}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Combine Player" />
          </ListItem>
        ) : (
          ""
        )}
        {user.isAdmin ||
        RoutePermissions.IsAuthorized(
          RouteScreens.CareerStatsDashboard,
          userAppRoles
        ) /* &&
          user.playerProfileFlag*/ ? (
          <ListItem button onClick={handleCareerStatsListClick}>
            <ListItemIcon>
              <PersonOutlineIcon />
            </ListItemIcon>
            <ListItemText primary="Career Stats" />
          </ListItem>
        ) : (
          ""
        )}

        {/* {
            RoutePermissions.IsAuthorized(RouteScreens.ManagePlayerCareerStats, userAppRoles) 
              ? (
                  <ListItem button onClick={handleManagePlayerCareerStatsClick}>
                      <ListItemIcon>
                        <AdminPanelSettingsIcon />
                      </ListItemIcon>
                      <ListItemText primary="Manage Player Career Stats" />
                    </ListItem>
                ) : ("")
        } */}
      </List>
    </Box>
  );

  return (
    <>
      {/* <Hidden smUp>
        <SwipeableDrawer
          anchor="left"
          open={props.open}
          className={classes.root}
          sx={{}}
          onClose={(e) => props.toggleDrawer(e, false)}
          //onOpen={(e) => props.toggleDrawer(e, true)}
        >
          {list()}
        </SwipeableDrawer>
      </Hidden> */}
      {/* <Hidden smDown> */}
      <Drawer
        anchor="left"
        className={classes.root}
        open={props.open}
        onClose={(e) => props.toggleDrawer(e, false)}
        //onOpen={(e) => props.toggleDrawer(e, true)}
      >
        {list()}
      </Drawer>
      {/* </Hidden> */}
    </>
  );
}
